import { createAuthLink } from 'aws-appsync-auth-link'
import config from './lib/appsync-config'

const authMiddleware = createAuthLink(config)

export default authMiddleware
